import Color from 'color';

const pageStyles = theme => ({
  page: {
    padding: "22px",
    position: "absolute",
    top: "0px",
    left: "0px",
    right: "0px",
    bottom: "0px",
    overflow: "auto"
  },
  pageHeader: {

  },
  pageContent: {
    marginTop: "15px",
    marginBottom: "20px",
  },
  pageFilters: {
    marginTop: "15px",
  },
  pageList: {
  },
  pageData: {
    padding: "5px 13px"
  },
  newButton: {
    padding: "6px 15px",
    fontSize: "18px"
  },
  formButtonsCard: {
    marginTop: "20px",
    position: "fixed",
    left: "217px",
    right: "23px",
    bottom: "0px",
    paddingBottom: "10px",
    zIndex: 1
  },
  formButtons: {
    display: "flex",
    padding: "10px 30px",
    paddingBottom: "10px !important",
    "& .MuiButton-root": {
      fontSize: "18px",
      minWidth: "125px"
    }
  },
  formButtonsLeft: {

  },
  formButtonsSpacer: {
    flexGrow: 1
  },
  formButtonsRight: {
    marginLeft: "10px"
  },
  formButton: {

  },
  delete: {
    backgroundColor: theme.palette.redError,
    "&:hover": {
      backgroundColor: Color(theme.palette.redError).darken(0.3).string(),
    },
  },
  hidden: {
    display: 'none'
  },
});

export default pageStyles;
